export default __webpack_public_path__ + "static/media/GunterIcon.f5a36b6b.png";